export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-gradient-to-r from-primary-500/10 via-accent-500/10 to-secondary-500/10 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[500px]">
                如果您有影片推荐、内容合作或任何问题反馈，欢迎通过以下方式联系我们。天美影视团队期待与您交流，共同打造更好的观影体验。
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
                <div className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <span>contact@tianmei.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-accent-600"></i>
                  </div>
                  <span>在线客服 7×24h</span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-auto shrink-0">
              <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-send-plane-line text-lg"></i>
                发送消息
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}